import utils from './utils';

const URL = `${BASE_API_URL}/demo`;

export default {
    getAvailableLessons: params => utils.get(`${URL}/list.json`, params),
    getAvailableEvents: params => utils.get(`${URL}/stat.json`, params),
    createCustomDemo: data => utils.post(`${URL}/custom.json`, data),
}



// WEBPACK FOOTER //
// ./src/api/demo.js